// frontend/src/components/ProtectRevenue.js
// "Protect your revenue" band — pro-rated cancellation fees + smart waitlist.
// Used on the landing (/why-ogestyle), /freelancer and /for-businesses pages.

import React from "react";
import { FaUndoAlt, FaUserClock } from "react-icons/fa";
import "./ProtectRevenue.css";

const tiers = [
  "96+ hrs notice — no fee",
  "48–96 hrs — keep 50%",
  "24–48 hrs — keep 75%",
  "Under 24 hrs — keep 100%",
];

export default function ProtectRevenue() {
  return (
    <section className="rp" aria-label="Protect your revenue">
      <div className="rp-wrap">
        <div className="rp-head">
          <p className="rp-eyebrow">Protect your revenue</p>
          <h2 className="rp-title">Late cancellations shouldn&rsquo;t cost you</h2>
          <p className="rp-sub">
            OGESTYLE handles the awkward part for you — fair cancellation fees
            for the time you held, and a waitlist that keeps your calendar full.
          </p>
        </div>

        <div className="rp-grid">
          <article className="rp-card">
            <span className="rp-ic">
              <FaUndoAlt />
            </span>
            <h3>Pro-rated cancellation fees</h3>
            <p>
              When a client cancels, your fee and their refund are calculated
              automatically from how much notice they give — so the appointment
              time you held stays compensated.
            </p>
          </article>

          <article className="rp-card">
            <span className="rp-ic">
              <FaUserClock />
            </span>
            <h3>Smart waitlist</h3>
            <p>
              A last-minute cancellation no longer means an empty slot. Clients
              on your waitlist are matched in automatically to fill it.
            </p>
          </article>
        </div>

        <div className="rp-tiers">
          {tiers.map((t) => (
            <span className="rp-tier" key={t}>
              {t}
            </span>
          ))}
        </div>
        <p className="rp-note">
          Notice before the appointment decides the cancellation fee you keep.
        </p>
      </div>
    </section>
  );
}
